module.exports = __webpack_public_path__ + "static/media/40x40-7.c5bf7a8e.png";